import { useRef, useState } from 'react'
import { useStore } from '../store'
import { probeVideo } from '../lib/media'

/** Màn hình bắt đầu: kéo-thả một hoặc NHIỀU video để ghép. */
export function ImportDropzone() {
  const inputRef = useRef<HTMLInputElement>(null)
  const [drag, setDrag] = useState(false)
  const addClip = useStore((s) => s.addClip)
  const setStatus = useStore((s) => s.setStatus)

  const addFiles = async (files: FileList) => {
    let added = 0
    for (const file of Array.from(files)) {
      if (!file.type.startsWith('video/')) continue
      const url = URL.createObjectURL(file)
      try {
        const meta = await probeVideo(url)
        addClip(file, meta)
        added++
      } catch (e) {
        setStatus(`⚠️ ${file.name}: ${(e as Error).message}`)
      } finally {
        URL.revokeObjectURL(url)
      }
    }
    if (added === 0) setStatus('⚠️ Vui lòng chọn file video hợp lệ.')
  }

  return (
    <div
      className={`dropzone ${drag ? 'drag' : ''}`}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault()
        setDrag(true)
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault()
        setDrag(false)
        if (e.dataTransfer.files.length) addFiles(e.dataTransfer.files)
      }}
    >
      <div className="dropzone-inner">
        <div className="logo-big">🎬 BrandCut</div>
        <p>Kéo-thả một hoặc nhiều video vào đây để ghép</p>
        <p className="muted">MP4, MOV, WebM… — xử lý 100% trên máy bạn, không upload.</p>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="video/*"
        multiple
        hidden
        onChange={(e) => {
          if (e.target.files) addFiles(e.target.files)
          e.target.value = ''
        }}
      />
    </div>
  )
}
